module.exports = __webpack_public_path__ + "img/banner-sm-03.2a1a9384.jpg";